import { msg } from '@lingui/core/macro';

export const t = {
    icons: {
        checkmark: msg({
            message: 'Checkmark in a blue circle',
            id: 'icon.checkmark.title',
            comment: 'Screen reader description for icon of checkmark in blue circle',
        }),
        shippingInTransit: msg({
            message: 'Package with speed lines at the back',
            id: 'icon.ShippingInTransit.title',
            comment: 'Screen reader description for icon of a parcel with speed lines ',
        }),
        heltHjem: msg({
            id: 'svg.HeltHjemLogo.title',
            comment: 'Screen reader description for "HeltHjem"-logo',
            message: 'Helthjem logo',
        }),
        posten: msg({
            id: 'svg.PostenLogo.title',
            comment: 'Screen reader description for "Posten"-logo',
            message: 'Posten logo',
        }),
        postNord: msg({
            id: 'svg.PostNordLogo.title',
            comment: 'Screen reader description for "PostNord"-logo',
            message: 'PostNord logo',
        }),
    },
    section: {
        ariaLabel: msg({
            id: 'section.FiksFerdig.ariaLabel',
            message: 'Buy item',
            comment: 'Aria label for the section containing the buy with Fiks Ferdig button',
        }),
    },
    payment: {
        errorMessage: msg({
            id: 'p.CantBuyOwnItem.validation',
            comment:
                'A validation message telling a seller that he/she cannot buy his/her own item',

            message: 'Whoops! You cannot buy your own item.',
        }),
    },
    makeSuggestion: {
        error: {
            title: msg({
                id: 'h3.notOptedIn.errorTitle',
                comment:
                    'This is an errormessage header shown to a buyer when a request for fiks ferdig did not go through',
                message: 'Oh no, something went wrong!',
            }),
        },
    },
    buyerProtectionModal: {
        title: msg({
            id: 'h1.buyerProtection.title',
            comment: 'Title for buyer protection section',
            message: 'Safe purchase with Ship-it',
        }),
        bullet: {
            one: msg({
                id: 'li.buyer.protection.modal.bullet.one',
                comment: 'First bullet point in buyer protection modal',
                message: 'The item will be sent to you.',
            }),
            two: msg({
                id: 'li.buyer.protection.modal.bullet.two',
                comment: 'Second bullet point in buyer protection modal',
                message: '24 hours to approve the item before the seller receives the payment.',
            }),
            three: msg({
                id: 'li.buyer.protection.modal.bullet.three',
                comment: 'Third bullet point in buyer protection modal',
                message: 'Our support if the item is not as advertised.',
            }),
        },
    },
    suggestShipping: {
        errorState: {
            header: msg({
                id: 'h3.notOptedIn.errorState',
                comment:
                    'This is an errormessage header shown to a buyer when a request for fiks ferdig did not go through',
                message: 'Something has gone wrong here!',
            }),
            info: msg({
                id: 'p.notOptedIn.errorState',
                comment:
                    'This is an errormessage shown to a buyer when a request for fiks ferdig did not go through',
                message:
                    'We could not tell the seller that you want to use Quick buy. You can send a message to the seller and continue without Quick buy.',
            }),
        },
    },
};
